module.exports = __webpack_public_path__ + "img/zavrit.01492e4d.svg";